<template>
  <div class="upload-mode-nav">
    <div
      v-if="!originateClient"
      class="nav"
    >
      <template v-for="item in navs">
        <span
          :key="item.key"
          :data-key="item.key"
          :class="{
            active: item.key === activePlatform,
          }"
          @click="handleSwitchNav"
        >{{ item.name }}</span>
      </template>
    </div>
    <div
      v-if="!originateClient"
      class="tips"
    >
      上传双端壁纸，可赚取更多收益~
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadModeNav',
  model: {
    prop: 'platform',
    event: 'change',
  },
  props: {
    platform: {
      type: String,
      default: 'pc',
    },
    originateClient: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activePlatform: this.platform,
      navs: [{
        key: 'pc',
        name: '电脑动态壁纸',
      }, {
        key: 'mobile',
        name: '手机动态壁纸',
      }, {
        key: 'all',
        name: '双端动态壁纸',
      }],
    }
  },
  watch: {
    platform(platform) {
      this.activePlatform = platform
    },
  },
  methods: {
    handleSwitchNav($event) {
      const key = $event.currentTarget.dataset.key
      this.activePlatform = key
      this.$emit('change', this.activePlatform)
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-mode-nav {
  min-height: 20px;
  .nav {
    display: flex;
    width: 384px;
    height: 40px;
    margin: 0 auto;
    padding: 0 3px;
    background: #F3F4F6;
    border-radius: 10px;
    span {
      flex: 1;
      height: 34px;
      margin-top: 3px;
      line-height: 34px;
      text-align: center;
      font-size: 12px;
      border-radius: 10px;
      cursor: pointer;
    }
    .active {
      background: #F4C000;
    }
  }
  .tips {
    margin-top: 10px;
    text-align: center;
    font-size: 12px;
    color: #E88E01;
    &::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      width: 13px;
      height: 13px;
      margin-right: 5px;
      background: url('~@/assets/images/upload/icon-info.png') 0 0 no-repeat;
    }
  }
}
</style>
